import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { getBrandsRequest } from "./api";
import { getBrands, setBrands } from "./actions";
import { brandsSelector } from "./selectors";

const brandsSchema = new schema.Entity("brands" , {}, { idAttribute: "code" });
const brandsListSchema = new schema.Array(brandsSchema);

export function* getBrandsWorker() {
    try {
        const { codes } = yield select(brandsSelector);
        if(!codes.length){
            yield put(setBrands({ isLoadingBrand: true }));
            const { brands } = yield call(getBrandsRequest);
            const { result, entities } = normalize(brands, brandsListSchema);
            yield put(setBrands({
                isLoadingBrand: false,
                codes: result,
                brands: entities.brands
            }));
        }
    } catch (error) {
        yield put(setBrands({ isLoadingBrand: false }));
        showError(error);
    }
}

export function* getBrandsSagas() {
    yield all([
        yield takeLatest(getBrands, getBrandsWorker)
    ]);
}
